import styled from 'styled-components'
import { LIVE_ACTIVE, LIVE_DISABLED } from '@/util/liveStreaming'

const LABELS = {
  [LIVE_ACTIVE]: 'LIVE',
  [LIVE_DISABLED]: 'DISABLED'
}

const LiveStatusBadge = ({ status }) => {
  const label = LABELS[status] || 'OFFLINE'
  const isActive = status === LIVE_ACTIVE

  return (
    <Badge $active={isActive} className="font-soehne-kraftig">
      {isActive && <Dot aria-hidden="true" />}
      {label}
    </Badge>
  )
}

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${(props) => (props.$active ? '#ffffff' : '#4b5563')};
  background: ${(props) => (props.$active ? '#c0392b' : '#e5e7eb')};
`

const Dot = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #ffffff;
  animation: live-pulse 1.6s ease-in-out infinite;

  @keyframes live-pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.25; }
  }
`

export default LiveStatusBadge
